import React, { Component } from "react";
// import {  } from '@alife/next';
import { connect } from "@alife/tarot";
import ClassNames from "classnames";
import ZrOfferGuess from "./zrOfferGuess";
import OfferGuess from "./offerGuess";
import Util from "../../util/common";

const getExpParams = (exp) => {
  let res = {};
  let configs = exp.split(";");
  configs.map((configStr) => {
    let key = configStr.split(":")[0];
    let val = configStr.split(":")[1];
    res[key] = val;
  });
  return res;
};

class GuessComponent extends Component {
  static propTypes = {};

  componentDidUpdate() {
    window.Light && window.Light.init();
  }
  
  componentWillMount() {
    const { dispatch } = this.props;
    //请求数据
    const t1 = setInterval(() => {
      if (Util.getPvid()) {
        window.clearInterval(t1);
        p4pObject.pageid = Util.getPvid();
        delete p4pObject.pid;
        dispatch("guess/getList", p4pObject);
      }
    }, 20);
  }
  render() {
    const { list = [], width } = this.props;
    const clswarp = ClassNames({
      clearfix: true,
      over_hid: true,
      w_1190: width === 1190,
      w_990: width === 990,
      w_1390: width === 1390,
    });

    const cls_list = ClassNames({
      mt20: true,
      over_hide: true,
      w_1210: width === 1190,
      w_1420: width === 1390,
      w_1024: width === 990,
      mb20: true,
    });
    if (list.length === 0) {
      return <div />;
    }

    // return <h1 style={{ color: "red" }}>fsdfsdfsd</h1>;
    return (
      <div className="bg_gray mt20 mb40">
        <div className={clswarp}>
          <div className={cls_list}>
            <div className="sm-block clearfix mb10">
              <h2>猜你喜欢</h2>
            </div>
            <div className="guessList">
              {list.map((item, index) => {
                item.isPcSem = true;
                return item.zhurong ? (
                  <ZrOfferGuess key={index} data={item} idx={index} />
                ) : (
                  <OfferGuess key={index} data={item} idx={index} />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  ...state.guess,
});
export default connect(mapStateToProps)(GuessComponent);
